var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.199,
    height: 21.198,
    viewBox: "0 0 21.199 21.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_459",
    "data-name": "Grupo 459",
    transform: "translate(-27.001 -27.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "zoom_out_FILL0_wght300_GRAD-25_opsz48",
    d: "M159.083,254.217l-7.625-7.631a6.288,6.288,0,0,1-2.188,1.288,7.705,7.705,0,0,1-2.562.441,7.576,7.576,0,1,1,7.045-4.978,7.694,7.694,0,0,1-1.3,2.267l7.689,7.623a.618.618,0,0,1,.173.487.773.773,0,0,1-.2.5.737.737,0,0,1-.533.217A.617.617,0,0,1,159.083,254.217Zm-12.4-7.283a6.108,6.108,0,1,0-4.395-1.786A5.937,5.937,0,0,0,146.683,246.934Z",
    transform: "translate(-112.115 -206.231)",
    fill: "#747683"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.31f0ebd6ac899a8130916a31b35aa025.svg";
export { ForwardRef as ReactComponent };